/* eslint-disable @typescript-eslint/no-explicit-any */
import { ReactElement, useEffect, useState } from "react";
import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogProps, DialogSurface, DialogTitle, DialogTrigger, Field, makeStyles, Textarea } from "@fluentui/react-components";
import { DocumentLinkRegular } from "@fluentui/react-icons";
import { Column, Row } from "../common";
import { useAccountState } from "../../redux/reducers/accountReducer";
import { useApi } from "../../data/api/useApi";

const useStyles = makeStyles({
    field: {
        width: '100%',
    },
});

export type SecureUploadLinkDialogProps = Partial<DialogProps> & {
    caseId?: string;
    children?: ReactElement<any>;
    open?: boolean;
    onOpenChange?: (isOpen: boolean) => void;
    onClickTrigger?: () => void;
}
export const SecureUploadLinkDialog = (props: SecureUploadLinkDialogProps) => {

    const { children, modalType, open = false, onOpenChange, onClickTrigger, caseId } = props;

    //Hooks
    const { primaryAccount } = useAccountState();
    const uploadLinkApi = useApi<string>(`api/SecureDocUpload/account/${primaryAccount?.account.accountId}`);

    //State
    const [linkText, setLinkText] = useState<string>('');
    const [isOpen, setIsOpen] = useState<boolean>(open);

    //Styles
    const styles = useStyles();

    //UI Events
    const clickNewLink = async (e: any) => {
        e.stopPropagation();
        const linkStr = await uploadLinkApi.postAsync(null, `case/${caseId}/secureUploadLink`);
        setLinkText(linkStr);
    }
    const clickCopyLink = (e: any) => {
        e.stopPropagation();
        if (linkText) {
            navigator.clipboard.writeText(linkText);
        }
    }
    const clickClose = (e: any) => {
        e.stopPropagation();
        setLinkText('');
    }

    //Effects
    useEffect(() => {
        setIsOpen(open);
    }, [open]);

    return (
        <>
            <Dialog modalType={modalType} open={isOpen} onOpenChange={(e, data) => {
                onOpenChange ? onOpenChange(data.open) : setIsOpen(data.open);
                !!onClickTrigger && onClickTrigger();
                e.stopPropagation();
            }}>
                <DialogTrigger disableButtonEnhancement>
                    {children}
                </DialogTrigger>
                <DialogSurface aria-describedby={undefined} mountNode={undefined}>
                    <DialogBody>
                        <DialogTitle>
                            <Row gap='medium'>
                                <Column width='auto' vAlign='middle'>
                                    <DocumentLinkRegular />
                                </Column>
                                <Column>
                                    Secure Document Upload Link
                                </Column>
                            </Row>
                        </DialogTitle>
                        <DialogContent>
                            <Field className={styles.field} label="Secure Link" >
                                <Textarea
                                    value={linkText}
                                    readOnly
                                    data-testid='secure-upload-link-textarea'
                                />
                            </Field>
                        </DialogContent>
                        <DialogActions fluid>
                            {!linkText &&
                                <Button appearance="primary" onClick={clickNewLink} data-testid='secure-upload-link-create-button'>Create new Upload Link</Button>
                            }
                            {!!linkText &&
                                <Button appearance="primary" onClick={clickCopyLink} data-testid='secure-upload-link-copy-button'>Copy Link</Button>
                            }
                            <DialogTrigger disableButtonEnhancement>
                                <Button appearance="secondary" onClick={clickClose} data-testid='secure-upload-link-close-button'>
                                    Close
                                </Button>
                            </DialogTrigger>
                        </DialogActions>
                    </DialogBody>
                </DialogSurface>
            </Dialog>
        </>
    );
}